import { render } from "./InfoOverviewPage.vue?vue&type=template&id=b3ad1468"
import script from "./InfoOverviewPage.vue?vue&type=script&lang=js"
export * from "./InfoOverviewPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__